import GlobalizationPage from "./GlobalizationPage";

export default GlobalizationPage;
